import PropTypes from 'prop-types'
import React from 'react'

import { EVENT_TYPE } from 'resources'

import { sendAnalyticsEvent } from 'services/analytics'

import { CategoryIcon, CategoryItem, CategoryName } from './styles'

const RewardCategoryItem = ({ category, columns, onClick }) => {
  const handleCategoryPress = () => {
    sendAnalyticsEvent(EVENT_TYPE.walletRewardsCategoryClick, { category: category.name })
    onClick()
  }

  return (
    <CategoryItem onClick={handleCategoryPress} columns={columns}>
      <CategoryIcon src={category.iconUrl} alt={category.name} />
      <CategoryName>{category.name}</CategoryName>
    </CategoryItem>
  )
}

RewardCategoryItem.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
  }).isRequired,
  columns: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default RewardCategoryItem
